// extracted by mini-css-extract-plugin
module.exports = {"loadingWrap":"Loading_loadingWrap_2XMzn","audio":"Loading_audio_342JZ","video":"Loading_video_31vSA","loading":"Loading_loading_GpPwl","rotate":"Loading_rotate_1LNgt"};